import React, { useState } from 'react';
import { api } from '../api';

export default function ValidateUrls() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  async function run() {
    setLoading(true);
    try {
      const { data: d } = await api.validateUrls();
      setData(d);
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  }

  return (
    <div>
      <div className="page-header">
        <div>
          <div className="page-title">Validate Patch URLs</div>
          <div className="page-subtitle">Check if all patch download URLs are reachable</div>
        </div>
        <button className="btn btn-primary" onClick={run} disabled={loading}>
          {loading ? '⟳ Checking...' : '▶ Run Validation'}
        </button>
      </div>

      {!data && !loading && (
        <div className="table-wrap" style={{ padding: 40, textAlign: 'center', color: '#64748b' }}>
          Click "Run Validation" to check all patch URLs
        </div>
      )}

      {loading && <div className="loading">Checking all patch URLs... this may take a moment.</div>}

      {data && (
        <>
          <div className="cards-row">
            <div className="card blue"><div className="card-label">Total</div><div className="card-value">{data.summary.total}</div></div>
            <div className="card green"><div className="card-label">Reachable</div><div className="card-value">{data.summary.reachable}</div></div>
            <div className="card yellow"><div className="card-label">Command-based</div><div className="card-value">{data.summary.commandBased}</div></div>
            <div className="card red"><div className="card-label">Failed</div><div className="card-value">{data.summary.failed}</div></div>
          </div>

          {/* Reachable */}
          <div className="table-wrap section-gap">
            <div className="table-header"><div className="table-title">✔ Reachable URLs ({data.results.reachable.length})</div></div>
            <table>
              <thead><tr><th>Vendor</th><th>Product</th><th>Version</th><th>Size</th><th>Status</th></tr></thead>
              <tbody>
                {data.results.reachable.length === 0 && <tr><td colSpan={5} className="empty">None</td></tr>}
                {data.results.reachable.map(p => (
                  <tr key={p.id}>
                    <td>{p.vendor}</td><td>{p.product}</td><td>{p.version}</td>
                    <td>{p.sizeMB ? `${p.sizeMB} MB` : '—'}</td>
                    <td><span className="badge success">✔ {p.statusCode}</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Command-based */}
          <div className="table-wrap section-gap">
            <div className="table-header"><div className="table-title">⚙ Command-based Patches ({data.results.commandBased.length})</div></div>
            <table>
              <thead><tr><th>Vendor</th><th>Product</th><th>Note</th></tr></thead>
              <tbody>
                {data.results.commandBased.length === 0 && <tr><td colSpan={3} className="empty">None</td></tr>}
                {data.results.commandBased.map(p => (
                  <tr key={p.id}>
                    <td>{p.vendor}</td><td>{p.product}</td>
                    <td style={{ color: '#64748b', fontSize: 12 }}>Runs OS command — no download needed</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Failed */}
          <div className="table-wrap">
            <div className="table-header"><div className="table-title">✘ Failed URLs ({data.results.failed.length})</div></div>
            <table>
              <thead><tr><th>Vendor</th><th>Product</th><th>Version</th><th>Reason</th><th>URL</th></tr></thead>
              <tbody>
                {data.results.failed.length === 0 && <tr><td colSpan={5} className="empty">All URLs are working 🎉</td></tr>}
                {data.results.failed.map(p => (
                  <tr key={p.id}>
                    <td>{p.vendor}</td><td>{p.product}</td><td>{p.version}</td>
                    <td><span className="badge failed">{p.reason}</span></td>
                    <td style={{ fontSize: 11, color: '#64748b', maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{p.url}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
}
